if (!customElements.get("add-to-recently-viewed")) {
    const MAX_ITEMS = 24; // możesz zmienić limit
  
    const addToRecentlyViewed = (handle, STORAGE_KEY) => {
      if (!handle) return;
  
      // Pobierz aktualną listę z localStorage
      let list;
      try {
        list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
        if (!Array.isArray(list)) list = [];
      } catch (e) {
        list = [];
      }
  
      // Usuń istniejące wystąpienie tego handle
      list = list.filter((h) => h !== handle);
  
      // Dodaj na początek (najnowszy pierwszy)
      list.unshift(handle);
  
      // Utnij listę do maksymalnej długości
      if (list.length > MAX_ITEMS) {
        list = list.slice(0, MAX_ITEMS);
      }
  
      // Zapisz z powrotem
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    };
  
    customElements.define(
      "add-to-recently-viewed",
      class AddToRecentlyViewed extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
          this.init();
        }
  
        init() {
         const STORAGE_KEY = "recently_viewed_handles_" + this.dataset.shopId;
          // pobieramy handle z atrybutu elementu
          const handle = this.dataset.handle || this.getAttribute("handle");
  
          console.log("init add to recently viewed, handle:", handle);
  
          addToRecentlyViewed(handle, STORAGE_KEY);
        }
      },
    );
  }


if (!customElements.get("recently-viewed-products")) {
  customElements.define(
    "recently-viewed-products",
    class RecentlyViewedProducts extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      async init() {
        const STORAGE_KEY = "recently_viewed_handles_" + this.dataset.shopId;
        const parsedList = JSON.parse(localStorage.getItem(STORAGE_KEY));
        const list = parsedList?.slice(0, this.dataset.productsToShow) || [];

        const hideEmptySection = this.dataset.hideEmptySection === '';
        if (list.length === 0 && hideEmptySection) {
          this.closest('section').classList.add('hidden');
        }
        console.log(list);

async function getProducts(handles) {
  const rootUrl = window.Shopify?.routes?.root || '/';

  const products = handles.map(handle => {
    return fetch(`${rootUrl}products/${handle}?view=recently-viewed-card`, {
      cache: 'force-cache'
    })
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc?.querySelector("[data-swiper-slide]").outerHTML;
      });
  });

  return Promise.all(products);
}

       try{
        const products = await getProducts(list);

        const swiper = this.querySelector("[data-swiper]");
        const swiperWrapper = this.querySelector("[data-swiper-container]");

        swiperWrapper.innerHTML = products.map(product => {
          return product;
        }).join('');

        const slideShow = this.querySelector("slideshow-section");
        slideShow.swiperInitilize();

        swiper.update();
       } catch(error) {
        console.error(error);
       }

      }
      

    },
  );
}